export const stage = "prod";
export const appName = "onl-shop";

export const ec2ApiEndpoint = "https://api.onl.taptag.co.kr";

export const authEndpoint = "https://auth.onl.taptag.co.kr/";

export const payEndpoint = "https://pay.onl.taptag.co.kr";

export const apiKey = "F43653B64C291AFDE25B7365A64970DE";

export const ec2Debug = false;
// export const ec2Debug = true;

export const dqrSettingDebug = false;
// export const dqrSettingDebug = true;

export const payApiDebug = false;
// export const payApiDebug = true;

export const swVersion = "v0.8.27.1"
export const debug = false;
// export const debug = true;

///////////////////////////////////////////////////////////////////////////////
export const ec2Api = {
  debug: ec2Debug,
  // endpoint_debug: "http://192.168.0.9:5000",   // 판교 405
  endpoint_debug: "http://localhost:5000",
  endpoint_public: ec2ApiEndpoint,
}

export const payApi = {
  debug: payApiDebug,
  endpoint_debug: "http://localhost:5050",
  // endpoint_debug: "http://192.168.0.9:5050",   // 판교 405
  endpoint_public: payEndpoint,
}

export const onlposApi = {
  // debug: true,
  debug: false,
  // endpoint_debug: "http://192.168.0.9:5317",   // 판교 405
  endpoint_debug: "http://localhost:5317",  
  endpoint_public: "https://api2.onl.taptag.co.kr",
}

export const prePayPosList = ["UNIONPOS", "OASIS_POS"]

// 
// dev 에서만 사용
// 
export const oasispos = {
  debug: ec2Debug,
  apiEndpoint_local: "http://localhost:5000",
  apiEndpoint_public: ec2ApiEndpoint,
}

//////////////////////////////////////////////////////////////////////////////
